// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".quen-unlock-widget{padding:20px 0}.quen-unlock-widget .describe{margin-bottom:40px}.quen-unlock-widget .stop-countdown{font-size:18px;margin-bottom:20px}.quen-unlock-widget.is-mobile{padding:10px}.quen-unlock-widget.is-mobile .stop-countdown{font-size:14px;margin-bottom:10px}.quen-unlock-widget.is-mobile .describe{margin-bottom:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"siteFontFamily": "system-ui,sans-serif,math,ui-rounded,ui-monospce"
};
module.exports = ___CSS_LOADER_EXPORT___;
